import React from 'react';
import { motion } from 'framer-motion';
export function WhyWorksSection() {
  const systemParts = ['Mente', 'Cuerpo', 'Hábitos', 'Comportamiento', 'Identidad'];
  return <section className="relative w-full bg-black py-8 md:py-12 overflow-hidden" data-id="element-459">
      <div className="absolute inset-0 z-0" data-id="element-460">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-red-800/15 blur-[140px]" data-id="element-461" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-[#0a0a0a] to-transparent z-10" data-id="element-462" />
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-463" />

      <div className="relative z-20 max-w-4xl mx-auto px-6 text-center" data-id="element-464">
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-465">
          <h2 className="font-display text-3xl md:text-5xl uppercase mb-3 text-white drop-shadow-[0_0_20px_rgba(220,38,38,0.3)]" data-id="element-466">
            <span className="text-red-500" data-id="element-467">🧠</span> ¿Por qué funciona?
          </h2>
          <p className="text-base md:text-lg text-gray-400 mb-8" data-id="element-468">
            Porque no ataca solo una parte. Ataca{' '}
            <span className="text-red-400 font-bold" data-id="element-469">TODO el sistema</span>:
          </p>

          <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-470">
            {systemParts.map((part, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08,
            duration: 0.4
          }} className="relative group" data-id="element-471">
                <div className="absolute -inset-0.5 bg-gradient-to-b from-red-600 to-red-900 rounded-lg blur opacity-30 group-hover:opacity-60 transition duration-500" data-id="element-472" />
                <div className="relative bg-[#0a0a0a] border border-red-900/50 px-5 py-3 rounded-lg" data-id="element-473">
                  <p className="text-sm md:text-base font-bold text-white uppercase tracking-wide flex items-center gap-2" data-id="element-474">
                    <span className="text-red-500" data-id="element-475">✓</span> {part}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}